import { enumTruckStatus } from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { TruckFormState } from '~/modules/transportation/types';

const initialState: TruckFormState = {
  status: enumTruckStatus.Available,
  licensePlate: '',
  model: '',
  country: '',
  state: '',
  transportationTypeId: '',
  facilityId: '',
};

export const $truckForm = atom<TruckFormState>(initialState);

export const $resetTruckForm = atom(null, (get, set) => {
  set($truckForm, initialState);
});

export const $updateTruckForm = atom(
  null,
  (get, set, update: Partial<TruckFormState>) => {
    const currentState = get($truckForm);
    set($truckForm, { ...currentState, ...update });
  },
);
